import { Role } from "../enums/role";

export function canRenameMedia(userRole: Role): boolean {
    if (userRole === Role.SUPER_ADMIN || userRole === Role.SYSTEM_ADMIN) {
        return true;
    }

    return false;
}
